import { Badge } from "@/components/ui/data-display/badge";
import type { GetFeedArticlesPagedFromProjectionArticle } from "@/data-access/news-feeds/queries/articles-management-queries";
import { useEnumLabel } from "@/hooks/useEnumLabel";
import { cn } from "@/lib/utils";
import { getPrettyName } from "@/lib/utils/prettyName";
import { useMemo } from "react";

type Props = Pick<
  GetFeedArticlesPagedFromProjectionArticle,
  "prominence" | "isLede" | "contentCategory" | "publisherTier"
> & {
  className?: string;
};

export const ArticleBadgeRow: React.FC<Props> = ({
  prominence,
  isLede,
  contentCategory,
  className,
  publisherTier,
}) => {
  const prominenceLabel = useEnumLabel("PROMINENCE", prominence);
  const categoryLabel = useEnumLabel("CATEGORY", contentCategory);

  const badges = useMemo(() => {
    const badgeLabels: string[] = [];

    if (
      categoryLabel &&
      categoryLabel.toLowerCase() !== "unknown" &&
      categoryLabel.trim() !== ""
    ) {
      badgeLabels.push(categoryLabel);
    }

    if (publisherTier) {
      badgeLabels.push(publisherTier);
    }

    if (prominenceLabel) {
      badgeLabels.push(prominenceLabel);
    }

    if (isLede) {
      badgeLabels.push("Lede");
    }

    return badgeLabels;
  }, [categoryLabel, publisherTier, prominenceLabel, isLede]);

  return (
    <div
      className={cn(
        "space-y-1 relative group items-center flex -my-2 -mx-2.5 rounded-sm",
        className,
      )}
    >
      <div className="flex gap-2 p-2.5">
        {badges.map((badge) => (
          <Badge
            key={badge}
            status={false}
            variant="white"
            bordered={true}
            className="font-semibold p-1"
          >
            {getPrettyName(badge)}
          </Badge>
        ))}
      </div>
    </div>
  );
};
